import {Dispatch, SetStateAction} from 'react'
import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
  RequestResult,
} from '../../lib'
import {QuestionnaireDisplayStrategyUpsertItem} from '../../model'
import {doREQUEST_ERROR, doREQUEST_COMPLETE, doMETHOD_UPDATE_QUESTIONNAIRE} from '../state'
import {getToken} from './token_fetcher'

export const REQUEST_QUESTIONNAIRE_DISPLAY_STRATEGY_UPSERT = 'REQUEST_QUESTIONNAIRE_DISPLAY_STRATEGY_UPSERT'
export const doREQUEST_QUESTIONNAIRE_DISPLAY_STRATEGY_UPSERT = createDoRequestAction(
  REQUEST_QUESTIONNAIRE_DISPLAY_STRATEGY_UPSERT,
)

export const requestQuestionnaireDisplayStrategyUpsertActionCreators = {
  doREQUEST_QUESTIONNAIRE_DISPLAY_STRATEGY_UPSERT,
}
interface Payload {
  payload: {
    requestId: string
    questionnaireId: string
    displayStrategyList: QuestionnaireDisplayStrategyUpsertItem[]
  }
  setRequestResult?: Dispatch<SetStateAction<RequestResult | null>>
  type: string
}

export function* requestQuestionnaireDisplayStrategyUpsert({payload, setRequestResult}: Payload): SagaIterator {
  debug('saga*requestQuestionnaireDisplayStrategyUpsert')

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        questionnaireId: v.string().uuid().exist(),
        displayStrategyList: v
          .array()
          .items(
            v
              .object({
                sectionId: v.string().uuid(),
                questionId: v.string().uuid(),
                displayStrategyId: v.string().uuid(),
                displayStrategy: v
                  .object({
                    displayLogicList: v
                      .array()
                      .items(
                        v.object({
                          type: v.string().exist(),
                          displayRuleList: v
                            .array()
                            .items(
                              v.object({
                                source: v.object().optional().allow(null),
                                condition: v.object().optional().allow(null),
                                target: v.object().optional().allow(null),
                              }),
                            )
                            .optional()
                            .allow(null),
                        }),
                      )
                      .optional()
                      .allow(null),
                  })
                  .required(),
              })
              .xor('sectionId', 'questionId', 'displayStrategyId')
              .required(),
          )
          .required(),
      }),
    })
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_QUESTIONNAIRE_DISPLAY_STRATEGY_UPSERT,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    )
  }

  const {questionnaireId, displayStrategyList} = payload

  const accessToken = yield call(getToken)

  const result = yield request({
    method: 'post',
    url: `${API_URL}/v1/web/questionnaire-display-strategy-upsert`,
    accessToken,
    data: {
      questionnaireId,
      displayStrategyList,
    },
  })

  if (!result.success || result.error) {
    const error = result.error || new Error('request did not succeed')
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_QUESTIONNAIRE_DISPLAY_STRATEGY_UPSERT,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    )
  }

  yield put(
    doMETHOD_UPDATE_QUESTIONNAIRE({
      ...result.payload,
    }),
  )

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_QUESTIONNAIRE_DISPLAY_STRATEGY_UPSERT,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  )
}

export function* questionnaireDisplayStrategyUpsertCreateSaga() {
  yield takeEvery(REQUEST_QUESTIONNAIRE_DISPLAY_STRATEGY_UPSERT, requestQuestionnaireDisplayStrategyUpsert)
}
